import { sendToSentry } from 'ComponentLibrary/src/common/sentry'
import { createContext, ReactNode, useContext, useState } from 'react'

export type ErrorSnackbarContent = {
    headline: string
    detail?: string
}

type ErrorSnackbarContext = {
    hasError: boolean
    error: ErrorSnackbarContent | null
    clearError: () => void
    handleError: (error: unknown) => void
} | null

const ErrorSnackbarContext = createContext<ErrorSnackbarContext>(null)

export const ErrorSnackbarProvider = ({
    children,
    errorHandler,
}: {
    children: ReactNode
    errorHandler: (error: unknown) => ErrorSnackbarContent | null
}) => {
    const [error, setError] = useState<ErrorSnackbarContent | null>(null)

    const clearError = () => setError(null)

    const handleError = async (error: unknown) => {
        // eslint-disable-next-line no-console
        console.error(error)
        sendToSentry(error)

        const errorContent = errorHandler(error)
        setError(errorContent)
    }

    return (
        <ErrorSnackbarContext.Provider value={{ hasError: !!error, error, clearError, handleError }}>
            {children}
        </ErrorSnackbarContext.Provider>
    )
}

export const useErrorSnackbar = () => {
    const context = useContext(ErrorSnackbarContext)

    if (context === undefined || context === null) {
        throw new Error(`useErrorSnackbar must be called within ErrorSnackbarProvider`)
    }
    return context
}
